import type { ModuloDelCatalogo, SolicitudResumen } from '@/api/negocios-cliente.api';

/** Pendientes (ENVIADA) primero; dentro de cada grupo, la más reciente arriba. */
export function ordenarSolicitudes(lista: SolicitudResumen[]): SolicitudResumen[] {
  return [...lista].sort(
    (a, b) =>
      Number(b.estado === 'ENVIADA') - Number(a.estado === 'ENVIADA') ||
      new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  );
}

/** Lo que se le puede dar a un cliente: construido y que no sea del OWNER (la API lo rechaza igual). */
export function modulosParaCliente(catalogo: ModuloDelCatalogo[]): ModuloDelCatalogo[] {
  return catalogo.filter((m) => m.construido && m.rolMinimo !== 'OWNER');
}

/** Casillas marcadas al abrir: lo propuesto que de verdad se puede elegir. */
export function marcadosAlAbrir(propuestos: string[], elegibles: ModuloDelCatalogo[]): string[] {
  const ids = new Set(elegibles.map((m) => m.id));
  return propuestos.filter((id) => ids.has(id));
}
